import { render, staticRenderFns } from "./OrgReferralFees.vue?vue&type=template&id=f00df13a&scoped=true&"
import script from "./OrgReferralFees.vue?vue&type=script&lang=js&"
export * from "./OrgReferralFees.vue?vue&type=script&lang=js&"
import style0 from "./OrgReferralFees.vue?vue&type=style&index=0&id=f00df13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00df13a",
  null
  
)

export default component.exports